import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["numero", "validade", "cvv", "nome"]
  // mask: padrão de dígitos do meio_pagamento. "9" = dígito, demais chars = literais.
  // vazio ou "AUTO" => máscara variável (Amex 4-6-5 / outras 4-4-4-4) detectada pelos dígitos.
  static values = { mask: { type: String, default: "" } }

  connect() {
    if (this.hasNumeroTarget)  this._setupNumero()
    if (this.hasValidadeTarget) this._setupValidade()
    if (this.hasCvvTarget)     this._setupCvv()
    if (this.hasNomeTarget)    this._setupNome()
  }

  // Reaplica a formatação/placeholder quando a máscara muda (ex.: troca de meio_pagamento).
  maskValueChanged() {
    if (!this.hasNumeroTarget) return
    const el = this.numeroTarget
    const max = this._maxLengthFor(el.value.replace(/\D/g, ""))
    if (max) el.setAttribute("maxlength", max)
    el.setAttribute("placeholder", this._placeholderFor())
    el.value = this._formatNumero(el.value.replace(/\D/g, ""))
  }

  // placeholder reflete a máscara: padrão fixo (9→0) ou genérico no modo AUTO
  _placeholderFor() {
    const pattern = this._fixedPattern()
    return pattern ? pattern.replace(/9/g, "0") : "0000 0000 0000 0000"
  }

  _setupNome() {
    this.nomeTarget.addEventListener("input", (e) => {
      const pos = e.target.selectionStart
      e.target.value = e.target.value.toUpperCase()
      e.target.setSelectionRange(pos, pos)
    })
  }

  // máscara fixa ativa? retorna o padrão, senão null (=> modo AUTO variável)
  _fixedPattern() {
    const m = (this.hasMaskValue ? this.maskValue : "").trim()
    if (m === "" || m.toUpperCase() === "AUTO") return null
    return m
  }

  _formatNumero(digits) {
    const pattern = this._fixedPattern()

    if (!pattern) {
      // AUTO: detecta bandeira pelos dígitos
      if (digits.startsWith("34") || digits.startsWith("37")) {
        digits = digits.slice(0, 15)
        return [digits.slice(0, 4), digits.slice(4, 10), digits.slice(10)].filter(Boolean).join(" ")
      }
      digits = digits.slice(0, 16)
      return digits.replace(/(.{4})/g, "$1 ").trim()
    }

    // máscara fixa: "9" consome dígito, demais chars são literais
    const max = (pattern.match(/9/g) || []).length
    digits = digits.slice(0, max)
    let out = "", di = 0
    for (let i = 0; i < pattern.length && di < digits.length; i++) {
      out += pattern[i] === "9" ? digits[di++] : pattern[i]
    }
    return out
  }

  // tamanho máximo do <input> (com separadores) para os dígitos atuais
  _maxLengthFor(digits) {
    const pattern = this._fixedPattern()
    if (pattern) return pattern.length
    return (digits.startsWith("34") || digits.startsWith("37")) ? 17 : 19
  }

  _setupNumero() {
    const el = this.numeroTarget
    el.setAttribute("placeholder", this._placeholderFor())

    const reformat = (e) => {
      const pos    = e.target.selectionStart
      const before = e.target.value.slice(0, pos).replace(/\D/g, "").length
      const digits = e.target.value.replace(/\D/g, "")
      const max    = this._maxLengthFor(digits)
      if (max) el.setAttribute("maxlength", max)
      const fmt    = this._formatNumero(digits)
      e.target.value = fmt
      let filled = 0, newPos = 0
      for (let i = 0; i < fmt.length && filled < before; i++) {
        if (/\d/.test(fmt[i])) filled++
        newPos = i + 1
      }
      e.target.setSelectionRange(newPos, newPos)
    }

    el.addEventListener("input", reformat)

    el.addEventListener("keydown", (e) => {
      if (e.key !== "Backspace") return
      const val = e.target.value
      const pos = e.target.selectionStart
      if (pos > 0 && /\D/.test(val[pos - 1])) {
        e.target.value = val.slice(0, pos - 1) + val.slice(pos)
        e.target.setSelectionRange(pos - 1, pos - 1)
        e.preventDefault()
      }
    })
  }

  _setupValidade() {
    this.validadeTarget.addEventListener("input", (e) => {
      const digits = e.target.value.replace(/\D/g, "").slice(0, 6)
      e.target.value = digits.length > 2
        ? digits.slice(0, 2) + "/" + digits.slice(2)
        : digits
    })
  }

  _setupCvv() {
    this.cvvTarget.addEventListener("input", (e) => {
      e.target.value = e.target.value.replace(/\D/g, "").slice(0, 4)
    })
  }
}
